import { useLocaleStore } from '../stores/locale';

export function localeRoute(path) {
  const localeStore = useLocaleStore();
  const locale = localeStore.currentLocale;

  if (locale === 'en') {
    return path.startsWith('/en') ? path : `/en${path}`;
  }

  return path.startsWith('/en') ? path.replace(/^\/en/, '') || '/' : path;
}

export function addLocalePrefix(path) {
  const localeStore = useLocaleStore();
  const locale = localeStore.currentLocale;

  // S'assurer que le path commence par /
  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  // Ajouter /en si locale anglaise et pas déjà présent
  if (locale === 'en' && !path.startsWith('/en')) {
    return '/en' + path;
  }

  // Enlever /en si locale française
  if (locale === 'fr' && path.startsWith('/en')) {
    return path.replace(/^\/en/, '') || '/';
  }

  return path;
}

export function removeLocalePrefix(path) {
  return path.replace(/^\/(en|fr)/, '') || '/';
}

export function getLocaleFromPath(path) {
  const match = path.match(/^\/(en|fr)/);
  return match ? match[1] : 'fr';
}
